import { Injectable } from '@angular/core';
import {NavigationCraft} from "../interface/navigation-craft";

@Injectable({
  providedIn: 'root'
})
export class GenerateNavigationUrlService {

	constructor() {
	}

	private _swatchKit: NavigationCraft = {
		"id": 66059,
		"segmentCategoryName": "SwatchKit",
		"optionList": [
			{
				"id": 11024021,
				"subCategoryName": "Embroidered"
			},
			{
				"id": 11026725,
				"subCategoryName": "Natural and Organic"
			},
			{
				"id": 11025402,
				"subCategoryName": "Premium Silk"
			},
			{
				"id": 11022824,
				"subCategoryName": "Printed Design"
			},
			{
				"id": 66079,
				"subCategoryName": "SWATCHKITS"
			},
			{
				"id": 11024649,
				"subCategoryName": "Yarn Dyed",
			}
		]
	}

	private _prepareUrl(param: string): string {
		if (param.includes('-'))
			return param.toLowerCase().replace(/\s+/g, '');
		return param.toLowerCase().replace(/\s+/g, '-');
	}

	public getUrl(param: string): string {
		return this._prepareUrl(param);
	}

	public generateRedirectionLink(url: string, name: string, value: string): string {
		return url + '?' + name + '=' + this._prepareUrl(value);
	}

	public generateCategoryRedirectionLink(url: string, segment: NavigationCraft, category?: string): string {

		if (segment.segmentCategoryName === "SwatchKit") {
			this._swatchKit = segment;
			segment.optionList = segment.optionList.filter((sub) => sub.subCategoryName !== 'Custom Product')
		}
		const segments: string[] = segment.optionList.map((sub) => this._prepareUrl(sub.subCategoryName));
		if (category) {
			return url + '?category=' + category + '&' + this._prepareUrl(segment.segmentCategoryName) + '=' + segments.join();
		}
		return url + '?' + this._prepareUrl(segment.segmentCategoryName) + '=' + segments.join();
	}


	public generateSegmentRedirectionLink(url: string, segment: string, subCategory: string, category?: string): string {
		if (category) {
			return url + '?category=' + category + '&' + this._prepareUrl(segment) + '=' + this._prepareUrl(subCategory);
		}
		return url + '?' + this._prepareUrl(segment) + '=' + this._prepareUrl(subCategory);
	}

	public redirectSwatchkitLink(url: string): string {
		const segments: string[] = this._swatchKit.optionList.filter((sub) => sub.subCategoryName !== 'Custom Product').map((sub) => this._prepareUrl(sub.subCategoryName));
		return url + '?' + this._prepareUrl(this._swatchKit.segmentCategoryName) + '=' + segments.join();
	}

}

